import { createClient } from '@supabase/supabase-js';

function isNewSupabaseApiKey(value) {
  return value.startsWith('sb_publishable_') || value.startsWith('sb_secret_');
}

function createSupabaseFetch(supabaseKey) {
  return (input, init) => {
    const headers = new Headers(
      typeof Request !== 'undefined' && input instanceof Request
        ? input.headers
        : undefined
    );

    if (init?.headers) {
      new Headers(init.headers).forEach((value, key) => headers.set(key, value));
    }

    // New Supabase API keys are opaque strings, not bearer JWTs
    if (
      isNewSupabaseApiKey(supabaseKey) &&
      headers.get('Authorization') === `Bearer ${supabaseKey}`
    ) {
      headers.delete('Authorization');
    }

    headers.set('apikey', supabaseKey);
    return fetch(input, { ...init, headers });
  };
}

// CRA uses process.env.REACT_APP_* (set in .env)
const SUPABASE_URL             = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  console.error(
    '[Supabase] Missing env vars: REACT_APP_SUPABASE_URL and/or REACT_APP_SUPABASE_PUBLISHABLE_KEY'
  );
}

export const supabase = createClient(
  SUPABASE_URL             || '',
  SUPABASE_PUBLISHABLE_KEY || '',
  {
    global: {
      fetch: createSupabaseFetch(SUPABASE_PUBLISHABLE_KEY || ''),
    },
    auth: {
      storage:          typeof window !== 'undefined' ? localStorage : undefined,
      persistSession:   true,
      autoRefreshToken: true,
    },
  }
);
